
export default function Panel_Invoices_Search_P()
{
  return (
    <div>
      <h1>صورتحساب ها</h1>
    </div>
  );
}
